(function () {
  var loaderScript = document.currentScript;
  var runtimeSource = loaderScript && loaderScript.dataset.swiperSrc;
  var runtimePromise = null;
  var runtimeElement = null;
  var readyDispatched = false;
  var triggerObserver = null;
  var triggerSelector = "[data-collection-carousel], [data-eyesnug-swiper-trigger]";
  var intentSelector =
    triggerSelector + ", [data-eyesnug-product-gallery], product-modal, .mobile-zoom-btn";

  function dispatchReady() {
    if (readyDispatched || typeof window.Swiper !== "function") return;
    readyDispatched = true;
    document.dispatchEvent(new CustomEvent("eyesnug:swiper-ready"));
  }

  function load(priority) {
    priority = priority === "high" ? "high" : "low";

    if (typeof window.Swiper === "function") {
      dispatchReady();
      return Promise.resolve(window.Swiper);
    }

    if (runtimePromise) {
      if (priority === "high" && runtimeElement) {
        runtimeElement.fetchPriority = "high";
      }
      return runtimePromise;
    }
    if (!runtimeSource) return Promise.resolve(null);

    runtimePromise = new Promise(function (resolve) {
      var runtime = document.createElement("script");
      runtimeElement = runtime;
      runtime.src = runtimeSource;
      runtime.async = true;
      runtime.fetchPriority = priority;
      runtime.dataset.eyesnugSwiperRuntime = "true";
      runtime.onload = function () {
        dispatchReady();
        resolve(window.Swiper || null);
      };
      runtime.onerror = function () {
        runtime.remove();
        runtimePromise = null;
        runtimeElement = null;
        resolve(null);
      };
      document.head.appendChild(runtime);
    });

    return runtimePromise;
  }

  function scheduleAfterLoad() {
    // Campaign pages with no slider only need the runtime if a component requests it.
    if (loaderScript && loaderScript.dataset.swiperOnDemand === "true") return;
    window.setTimeout(function () {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(load, { timeout: 3000 });
      } else {
        load();
      }
    }, 30000);
  }

  function observeTriggers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var triggers = scope.querySelectorAll(triggerSelector);
    if (!triggers.length) return;

    if (!("IntersectionObserver" in window)) {
      load();
      return;
    }

    if (!triggerObserver) {
      triggerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          triggerObserver.unobserve(entry.target);
          load();
        });
      }, { rootMargin: "300px 0px", threshold: 0.01 });
    }

    triggers.forEach(function (trigger) {
      triggerObserver.observe(trigger);
    });
  }

  function loadFromIntent(event) {
    var target = event.target;
    if (!(target instanceof Element) || !target.closest(intentSelector)) return;
    load("high");
  }

  ["pointerover", "pointerdown", "touchstart", "wheel", "keydown", "focusin"].forEach(function (eventName) {
    document.addEventListener(eventName, loadFromIntent, {
      capture: true,
      passive: eventName !== "keydown",
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    observeTriggers(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    observeTriggers(event.target);
  });

  if (document.readyState === "complete") {
    scheduleAfterLoad();
  } else {
    window.addEventListener("load", scheduleAfterLoad, { once: true });
  }

  window.EyesnugSwiperLoader = {
    load: load,
    loadFromIntent: loadFromIntent,
    observeTriggers: observeTriggers,
  };
})();
